import React from "react";
import { useState, createContext } from "react";

export const UIDContext = createContext();

export const UIDProvider = (props) => {
  const [uid] = useState([
    {
      id: "31",
      name: "REST API Countries",
      description: "Project built using REST Countries API",
      deploy: false,
      deployment: "",
      code: "https://github.com/shelcia/countries",
    },
    {
      id: "32",
      name: "Samgatha",
      description:
        "I was commisioned to build website for college cultural fest",
      deploy: true,
      deployment: "http://www.samgatha.live/",
      code: "https://github.com/shelcia/Samgatha-2020",
    },
  ]);
  return (
    <UIDContext.Provider value={uid}>{props.children}</UIDContext.Provider>
  );
};
